var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgActiveIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.668,
    height: 19.501,
    viewBox: "0 0 18.668 19.501",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9199",
    "data-name": "Grupo 9199",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1390",
    "data-name": "Grupo 1390",
    transform: "translate(0 2.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2658",
    "data-name": "Caminho 2658",
    d: "M672.224,516.611A9.059,9.059,0,0,1,666.77,500.3a.825.825,0,1,1,1,1.316,7.433,7.433,0,1,0,8.914,0,.825.825,0,1,1,1-1.316,9.058,9.058,0,0,1-5.452,16.312Z",
    transform: "translate(-663.14 -500.132)",
    fill: "#33bc6b",
    stroke: "#33bc6b",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1391",
    "data-name": "Grupo 1391",
    transform: "translate(8.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2659",
    "data-name": "Caminho 2659",
    d: "M668.966,508.515a.824.824,0,0,1-.826-.826v-8.258a.826.826,0,0,1,1.652,0v8.258A.825.825,0,0,1,668.966,508.515Z",
    transform: "translate(-668.14 -498.605)",
    fill: "#33bc6b",
    stroke: "#33bc6b",
    strokeWidth: 0.5
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgActiveIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/active_icon.0e91bfab.svg";
export { ForwardRef as ReactComponent };